import { text_colorTextPrimary } from 'ext-ui/style/colors'
import { fontH1, fontH2 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

// Native heading tags inherit the UA `font-weight: bold`, which faux-bolds our
// Rubik-Medium face. Reset the weight to normal so the Medium face renders as
// designed while keeping the semantic <h1>/<h2> element.
export const page = css`
  ${fontH1}
  font-weight: normal;
  color: ${text_colorTextPrimary};
  margin: 0;
`

export const section = css`
  ${fontH2}
  font-weight: normal;
  color: ${text_colorTextPrimary};
  margin: 0;
`
